import React from "react";
import './style.scss';
import Dropdown from "../Dropdown";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";
import { useSelector } from "react-redux";

const ProductLineControl = ({onPropChange, item, column, useParentMenu}) => {
    const menu = useSelector(state => state.restaurant.data.businessMenu);
    const parentMenu = useSelector(state => state.restaurant.data.parentMenu);

    const productLines = React.useMemo(() => {
        const products = useParentMenu ? parentMenu?.categories?.flatMap(c => c.products) || [] : [];
        const overides = [...new Set(menu?.overrides?.filter(ov => ov.name === "production_line")?.map(o => o.value.trim()))];

        const suboptions = (useParentMenu ? products : menu?.categories?.flatMap(c => c.products))
            ?.flatMap(product => product.extras)
            ?.flatMap(extra => extra.options)
            ?.flatMap(option => option.suboptions)
            || [];

        return products.concat(suboptions).concat(menu?.categories?.flatMap(c => c.products)).filter(Boolean)?.reduce((acc, cv) => {
            if(cv.production_line && !acc.includes(cv.production_line)) {
                acc.push(cv.production_line.trim());
            }
            return acc;
        }, overides).map(p => ({production_line: p}));
    }, [menu, parentMenu, useParentMenu]);

    const onChangeAddress = (val) => {
        onPropChange({production_line: val});
    }

    const hasValue = productLines.find(p => p.production_line === item?.production_line);

    return (
        <div className="productLineControl">
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            <Dropdown
                readonly={false}
                values={[].concat(item?.production_line && !hasValue ? {production_line: item?.production_line} : null).concat(productLines).filter(Boolean)}
                labelField="production_line"
                valueField="production_line"
                searchBy="production_line"
                sortBy="production_line"
                value={item?.production_line || ''}
                onSelect={val=> onChangeAddress(val.production_line)}
                onChange={onChangeAddress}
            />
        </div>
        
    )
}

export default ProductLineControl;